import React from 'react';
import PropTypes from 'prop-types';

export const FormSubmitButton = ({
  children,
  disabled = false,
  type = 'submit',
  ...props
}) => {
  return (
    <button
      className="swformsubmit__btn"
      type={type}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

FormSubmitButton.propTypes = {
  children: PropTypes.any.isRequired,
  disabled: PropTypes.bool,
  type: PropTypes.string
};
